@switch (sizeCode()) {
  @case ("Z") {
    <div label>
      <span>{{ size() | number }} </span>
      <span>{{ 1 | i18nPlural: unitLabel() }} </span>
      <span>custom cut</span>
    </div>
  }
  @default {
    <div label>
      <span size>{{ size() | number }} </span>
      <span unit>{{ 1 | i18nPlural: unitLabel() }} </span>
      <span container-unit>{{ 1 | i18nPlural: containerUnitLabel() }}</span>
    </div>
  }
}
